/**
 * Extracts the first part of a string (before the first space)
 * Used for extracting unit values from formatted strings like "kWh (kilowatt-hour)"
 */
export function extractValue(inputString: string): string {
  const trimmedString = inputString.trim();
  const firstPart = trimmedString.split(" ")[0];
  return firstPart;
}

